<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="dismiss()">
        <ion-icon name="arrow-back-circle-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="ion-text-start"> {{ info.nombre }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding-horizontal">
  <div class="center">
    <ion-grid fixed>
      <ion-row>
        <ion-col
          size="12"
          style="display: flex; justify-content: center; align-items: center"
        >
          <ion-avatar *ngIf="!!lugarImg">
            <img [src]="lugarImg" />
          </ion-avatar>
        </ion-col>
      </ion-row>
      <ng-container *ngIf="info.no_data; else showData">
        <ion-row>
          <ion-col
            size="12"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
            "
          >
            <ion-text color="dark ion-text-center">
              <h3 style="margin-bottom: 8px">
                {{ info.no_data }}
              </h3>
            </ion-text>
          </ion-col>
        </ion-row>
      </ng-container>

      <ng-template #showData>
        <ion-row>
          <ion-col size="12">
            <ion-text color="dark" class="ion-text-center" *ngIf="info.titulo">
              <h6 style="font-weight: bold; font-size: 15px">
                {{ info.titulo }}
              </h6>
            </ion-text>
            <ng-container *ngIf="info.descripcion">
              <div
                style="margin-top: 8px"
                [innerHtml]="info.descripcion | safeHtml"
              ></div>
            </ng-container>
            <!-- NORMAL CARD   -->
            <ng-container *ngIf="!info.descripcion">
              <ion-row *ngFor="let bloque of info.eg_bloques">
                <ion-col
                  size="12"
                  style="
                    display: flex;
                    justify-content: flex-start;
                    flex-direction: column;
                  "
                >
                  <ion-text color="dark">
                    <h2 style="font-weight: bold">
                      {{ bloque.metodologia.nombre }}
                    </h2>
                  </ion-text>
                  <!-- EJERCICIOS  -->
                  <ng-container
                    *ngFor="let exercise of bloque.eg_bloque_ejercicios"
                  >
                    <div
                      style="margin-left: -40px; margin-top: 8px"
                      [innerHtml]="exercise.descripcion_enlace | safeHtml"
                    ></div>
                  </ng-container>
                  <!-- EXPLICACION EJERCICIO  -->

                  <ion-text color="dark">
                    <h2
                      style="
                        margin-bottom: 8px;
                        margin-top: 8px;
                        font-weight: bold;
                      "
                      (click)="bloque.showDescripcion = !bloque.showDescripcion"
                    >
                      {{ bloque.titulo }}
                      <ion-icon
                        [name]="
                          !bloque.showDescripcion
                            ? 'chevron-down-outline'
                            : 'chevron-up-outline'
                        "
                        slot="end"
                        *ngIf="info.expanded"
                      ></ion-icon>
                    </h2>
                  </ion-text>
                  <ion-text>
                    <p
                      class="animate__animated animate__slideInUp"
                      style="margin-bottom: 8px; font-size: 14px"
                      *ngIf="bloque.showDescripcion"
                    >
                      {{ bloque.descripcion }}
                    </p>
                  </ion-text>
                </ion-col>
              </ion-row>

              <!-- VIDEO  -->
              <ion-row>
                <ion-col>
                  <ng-container *ngIf="info.url_video">
                    <iframe
                      width="100%"
                      height="250px"
                      [src]="info.url_video | safe"
                      allowfullscreen
                    >
                    </iframe>
                  </ng-container>
                </ion-col>
              </ion-row>
            </ng-container>
          </ion-col>
        </ion-row>
      </ng-template>

      <ion-row>
        <ion-col
          size="12"
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
          "
        >
          <h5>¿No entiendes algo? Pregúntanos</h5>
          <!-- <ion-button
            (click)="socialMedia('whatsapp')"
            expand="full"
            color="success"
            style="width: 100%"
            [disabled]="!this.waPhone"
          >
            Abrir Whatsapp
          </ion-button> -->
          <app-wa-button type="button"></app-wa-button>
        </ion-col>
      </ion-row>

      <ng-template #spinner>
        <div class="spinner" style="height: 100%">
          <ion-row>
            <ion-col
              size="12"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <ion-spinner></ion-spinner>
            </ion-col>
          </ion-row>
        </div>
      </ng-template>
    </ion-grid>
  </div>
</ion-content>
